import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { ConfigService } from './config.service';
import {
  CreditRejectionRequest,
  FincoreResponseEnvelope,
  ResendSmsRequest,
  UpdateAtaStatusRequest,
  UpdateAtaStatusResponse,
} from '../model/fincore';
import {
  createFincoreHeaders,
  handleFincoreHttpError,
  resolveFincoreBaseUrl,
} from '../util/fincore-http';

@Injectable({
  providedIn: 'root',
})
export class FincoreAccountMaintenanceService {
  private URL: string;
  private prefix: string;

  constructor(
    @Inject(ConfigService) private config: any,
    private httpClient: HttpClient
  ) {
    this.URL = resolveFincoreBaseUrl(this.config);
    this.prefix = `${this.URL}/account-maintenance`;
  }

  updateAtaStatus(
    request: UpdateAtaStatusRequest
  ): Observable<UpdateAtaStatusResponse> {
    const headers = createFincoreHeaders();
    return this.httpClient
      .post<UpdateAtaStatusResponse>(
        `${this.prefix}/update-ata-status`,
        request,
        { headers }
      )
      .pipe(catchError(handleFincoreHttpError));
  }

  creditRejection(
    bankAccountNo: string
  ): Observable<FincoreResponseEnvelope | null> {
    const headers = createFincoreHeaders();
    const body: CreditRejectionRequest = { bankAccountNo };
    return this.httpClient
      .post<FincoreResponseEnvelope>(`${this.prefix}/credit_rejection`, body, {
        headers,
      })
      .pipe(catchError(handleFincoreHttpError));
  }

  resendSms(id: number | string): Observable<FincoreResponseEnvelope | null> {
    const headers = createFincoreHeaders();
    const body: ResendSmsRequest = { id };
    return this.httpClient
      .post<FincoreResponseEnvelope>(`${this.prefix}/resend-sms`, body, {
        headers,
      })
      .pipe(catchError(handleFincoreHttpError));
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Added FincoreAccountMaintenanceService with HttpClient methods for FinCore account-maintenance APIs. Previous behavior: No portaladmin client existed for ATA status, credit rejection, or resend SMS. New behavior: Service resolves {FINCORE host|REST_SERVER_HOST}/api/fincore/account-maintenance and exposes updateAtaStatus POST /update-ata-status (id and/or ids, status label or 1-11, required reason), creditRejection POST /credit_rejection {bankAccountNo} (204 empty body possible), resendSms POST /resend-sms {id}. Reason: Replicate FinCore REST API V1.000 account-maintenance operations in portaladmin without UI. Context: Backend APIs not used by current FinCore Angular UI but required by the integration spec. Impact: providedIn root; 204 responses may be null; DoNotIntercept headers match RtcService; no components wired. - 2026-08-20 - HE
